module.exports = __webpack_public_path__ + "static/media/advantages_bar_bottom.0042b5a1.svg";